import { claimPlayer as claimPlayerApi, searchPlayer as searchPlayerApi } from '@/services'
import { FilterSearchPlayer, PayloadSearchPlayer, ResultSearchPlayer, SearchPlayerResponse } from '@/types'
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
interface PlayerStore {
  isLoading: boolean
  resSearchPlayer: ResultSearchPlayer
  searchText: string
  filter: FilterSearchPlayer & { locationText?: string }
}

export const SearchPlayerPrefix = '@Player/SearchPlayer'
export const ClaimPlayerPrefix = '@Player/ClaimPlayer'

export const searchPlayer = createAsyncThunk(SearchPlayerPrefix, async (payload: PayloadSearchPlayer) => {
  return await searchPlayerApi(payload)
})

export const claimPlayer = createAsyncThunk(ClaimPlayerPrefix, async (payload: PayloadSearchPlayer) => {
  return await claimPlayerApi(payload)
})

const initialState: PlayerStore = {
  isLoading: false,
  resSearchPlayer: {
    offset: 0,
    limit: 10,
    total: 0,
    hits: [],
    totalValueRelation: null,
    hasMore: false,
    hasPrevious: false,
    empty: false,
  },
  filter: {
    lat: 0,
    lng: 0,
    rating: {
      maxRating: null,
      minRating: null,
    },
    locationText: '',
  },
  searchText: '',
}

const playerSlice = createSlice({
  name: 'PLAYER_SLICE',
  initialState,
  reducers: {
    resetPlayer: (state) => {
      Object.assign(state, initialState)
    },
    receiveSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload
    },
    receiveFilter: (state, action: PayloadAction<FilterSearchPlayer & { locationText?: string }>) => {
      state.filter = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(searchPlayer.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(searchPlayer.fulfilled, (state, action: PayloadAction<SearchPlayerResponse>) => {
      if (action.payload.result.offset === 0) {
        state.resSearchPlayer = action.payload.result
      }
      if (action.payload.result.offset !== 0) {
        const updatedResSearchPlayer = {
          ...state.resSearchPlayer,
          empty: action.payload.result.empty,
          hasMore: action.payload.result.hasMore,
          hasPrevious: action.payload.result.hasPrevious,
          hits: [
            ...new Map(
              [...state.resSearchPlayer.hits, ...action.payload.result.hits].map((item) => [item.id, item])
            ).values(),
          ],
          limit: action.payload.result.limit,
          offset: action.payload.result.offset,
          total: action.payload.result.total,
          totalValueRelation: action.payload.result.totalValueRelation,
        }
        state.resSearchPlayer = updatedResSearchPlayer
      }

      state.isLoading = false
    })
    builder.addCase(searchPlayer.rejected, (state) => {
      state.isLoading = false
    })

    builder.addCase(claimPlayer.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(claimPlayer.fulfilled, (state, action: PayloadAction<SearchPlayerResponse>) => {
      if (action.payload.result.offset === 0) {
        state.resSearchPlayer = action.payload.result
      }
      if (action.payload.result.offset !== 0) {
        const updatedResSearchPlayer = {
          ...state.resSearchPlayer,
          empty: action.payload.result.empty,
          hasMore: action.payload.result.hasMore,
          hasPrevious: action.payload.result.hasPrevious,
          hits: [
            ...new Map(
              [...state.resSearchPlayer.hits, ...action.payload.result.hits].map((item) => [item.id, item])
            ).values(),
          ],
          limit: action.payload.result.limit,
          offset: action.payload.result.offset,
          total: action.payload.result.total,
          totalValueRelation: action.payload.result.totalValueRelation,
        }
        state.resSearchPlayer = updatedResSearchPlayer
      }

      state.isLoading = false
    })
    builder.addCase(claimPlayer.rejected, (state) => {
      state.isLoading = false
    })
  },
})

const { reducer, actions } = playerSlice

export const { resetPlayer, receiveSearchText, receiveFilter } = actions

export default reducer
